import { Link } from "react-router-dom";
import { bortleLabel, bortleTone, TAG_LABELS } from "../../lib/access";
import type { Site } from "../../types";

interface SiteCardProps {
  site: Site;
  miles?: number;
  compact?: boolean;
  onSelect?: (site: Site) => void;
}

const SiteCard = ({ site, miles, compact, onSelect }: SiteCardProps) => {
  const inner = (
    <>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="font-bold text-ray leading-tight">{site.shortName}</h3>
          <p className="text-xs text-alt-wht/70 mt-0.5">
            {site.region} · {site.state}
            {miles != null ? ` · ${miles < 10 ? miles.toFixed(1) : Math.round(miles)} mi` : ""}
          </p>
        </div>
        <div className="text-right shrink-0">
          <div className="text-xs font-semibold text-foam">{bortleLabel(site.bortle)}</div>
          <div className="text-[10px] text-alt-wht/50">{bortleTone(site.bortle)}</div>
        </div>
      </div>
      {!compact && (
        <p className="text-sm text-alt-wht/85 mt-2 line-clamp-3">{site.whyGood}</p>
      )}
      <div className="flex flex-wrap gap-1.5 mt-2">
        {site.tags.slice(0, compact ? 3 : 5).map((tag) => (
          <span
            key={tag}
            className="text-[10px] uppercase tracking-wide px-2 py-0.5 rounded-full border border-white/15 text-alt-wht/80"
          >
            {TAG_LABELS[tag]}
          </span>
        ))}
      </div>
    </>
  );

  if (onSelect) {
    return (
      <button
        type="button"
        onClick={() => onSelect(site)}
        className="w-full text-left rounded-xl bg-white/5 hover:bg-white/10 p-3 transition-colors"
      >
        {inner}
      </button>
    );
  }

  return (
    <Link
      to={`/sites/${site.id}`}
      className="block rounded-2xl bg-alt-blk text-alt-wht p-5 hover:bg-alt-blk/90 transition-colors h-full"
    >
      {inner}
    </Link>
  );
};

export default SiteCard;
